import { PieChartDatum } from '@quality24/design-system';
import { sanitizeKey } from '../../../../utils/dataUtils';

/**
 * Maps the data to a Pie chart in the format:
 * {
 *   id: entry.key
 *   label: entry.key
 *   value: entry.value
 * }
 */
export const formatChartData = (
  data: Array<Record<string, string | number>>,
  displayFirst?: number,
  groupOthers?: boolean,
  skipSort?: boolean,
): Array<PieChartDatum> => {
  const chartData = data.flatMap<PieChartDatum>((d) =>
    Object.entries(d)
      .filter(([k]) => k !== '_original')
      .map(([key, value]) => ({
        id: `${sanitizeKey(key)}`,
        label: `${sanitizeKey(key)}`,
        value: Math.round(value as number),
      })),
  );

  if (!skipSort) {
    // sort the data by highest to lowest
    chartData.sort((a, b) => b.value - a.value);
  }

  let result = [...chartData];
  // Filter only first entries
  if (displayFirst && displayFirst > 0 && chartData.length > displayFirst) {
    // filter n first entries
    result = chartData.filter((_d, idx) => idx < displayFirst);

    // group other entries in a bin
    if (groupOthers) {
      result.push({
        id: 'Outros',
        label: 'Outros',
        value: chartData
          .filter((_d, idx) => idx >= displayFirst)
          .reduce((acc, v) => acc + v.value, 0),
      });
    }
  }

  return result;
};

export default formatChartData;
